import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import propTypes from './propTypes';

const I18nProvider = ({ children, locale: localeFromProps }) => {
    const { locale: localeFromContext } = getContext();
    const locale = localeFromProps || localeFromContext;
    const contextualizedI18n = i18n.spawn(locale);

    return children({ i18n: contextualizedI18n });
};

I18nProvider.propTypes = {
    ...propTypes
};

export default I18nProvider;
